import { PlayIcon } from "@/assets/icons";
import HeroSection from "@/components/landing-page/HeroSection";

export default function FansHeroSection() {
  return (
    <HeroSection
      video={{
        webm: "/videos/hero-fan-2.webm",
        mp4: "/videos/hero-fan-2.mp4",
        poster: "/videos/hero-fan-poster.jpg",
      }}
      headline={"Own the music you love"}
      subtitleMaxWidth="none"
      subtitle={
        <>
          Get music directly from your favorite artists.
          <br /> Stream it, download it, and unlock exclusive content and early
          access to new releases.
        </>
      }
      primaryCta={{
        icon: PlayIcon,
        label: "Start Listening",
        to: "/marketplace",
      }}
      secondaryCta={{
        label: "For Artists & Labels",
        to: "/artists",
      }}
    />
  );
}
